export default {
  SPIN: 'สปิน',
  'You are not eligible for free spins':
    'เฉพาะบัญชี Steam ที่มีเกม CSGO เท่านั้น และ VAC ไม่มีสิทธิ์รับเหรียญฟรี ลงชื่อเข้าใช้ในระบบอีกครั้งเพื่ออัปเดต',
  'It must be 24 hours since last roll': 'เฉพาะหลังจากโรลครั้งล่าสุดไปแล้ว 24 ชั่วโมงเท่านั้น',
};
